import '../public/icon/style.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import axios from 'axios'
import firebase from 'firebase/app';
import 'firebase/auth';
import './stylus/override.styl';
import { CONFIG } from './config';
import './registerServiceWorker'

Vue.config.productionTip = false;

Vue.prototype.$eventBus = new Vue();
// Vue.prototype.$storage = process.env.VUE_APP_STORAGE_URL;
// Vue.prototype.$CDN = process.env.VUE_APP_CDN;
// Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL;
Vue.prototype.$storage = CONFIG.S3;
Vue.prototype.$CDN = CONFIG.CDN;
Vue.prototype.$baseUrl = CONFIG.BASE_URL;
Vue.prototype.$api = CONFIG.API;
Vue.prototype.$inipayMID = CONFIG.MID;

// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.defaults.baseURL = CONFIG.API;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// firebase init
let config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: 'glorang-205104.firebaseapp.com',
  databaseURL: 'https://glorang-205104.firebaseio.com',
  projectId: 'glorang-205104',
  storageBucket: 'glorang-205104.appspot.com',
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
};
firebase.initializeApp(config);

try {
  Kakao.init(process.env.VUE_APP_KAKAO_API_KEY);
} catch (e) {
  console.error(e);
}

// inicis payment init
if (navigator.userAgent.includes('Mobi')) {
	NodeINIStdPay.init({ paymentUrl: `${CONFIG.API}/v3/payment` });
} else {
	NodeINIStdPay.init();
}

let youthApp = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

// // 네이티브 소셜로그인 인터페이스
// Vue.prototype.$signSuccess = function (user) {
//   console.log('signSuccess: ', user);
//   youthApp.$eventBus.$emit('signSuccess', user);
// };
// Vue.prototype.$signCancel = function () {
//   console.log('signCancel');
//   youthApp.$eventBus.$emit('signCancel');
// };
